import React, { useState, useMemo, useCallback } from 'react'
import { Slate, Editable, withReact } from 'slate-react'
import { createEditor, Node } from 'slate'
import { css } from 'emotion'
import { withHistory } from 'slate-history'

export const BaseExample = () => {
  const [value, setValue] = useState<Node[]>(initialValue)
  const renderElement = useCallback((props) => <p {...props} />, [])
  const editor = useMemo(() => withHistory(withReact(createEditor())), [])

  return (
    <Slate editor={editor} value={value} onChange={(value) => setValue(value)}>
      <Editable
        className={css`
          margin: 1em;
          padding: 0.2em;
          border: solid 1px grey;
          min-height: 5em;
        `}
        renderElement={renderElement}
        placeholder="Get to work…"
        spellCheck
        autoFocus
      />
    </Slate>
  )
}

const initialValue = [{ children: [{ text: '' }] }]
